import React, { useState } from 'react';
import './OvvoLogin.scss';
import api from '../Axios/axios';
import { useNavigate } from 'react-router-dom';

const OvvoLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [isForgotModalOpen, setIsForgotModalOpen] = useState(false);
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);

  const [forgotEmail, setForgotEmail] = useState('');
  const [resetCode, setResetCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [loginError, setLoginError] = useState(null);
  const [resetError, setResetError] = useState(null);
  const [resetSuccess, setResetSuccess] = useState(false);

  const navigate = useNavigate();

  const getDefaultRouteByRole = () => {
    return '/home';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/Auth/Login', { email, password });
      if (response.status === 200 && response.data?.data?.token) {
        const token = response.data.data.token;
        localStorage.setItem('token', token);
        setLoginError(null);

        // rol kontrolü
        let userRole = '';
        try {
          const payload = JSON.parse(atob(token.split('.')[1]));
          userRole =
            payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || '';
        } catch {}

        navigate(getDefaultRouteByRole(userRole), { replace: true });
      } else {
        setLoginError('Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.');
      }
    } catch (error) {
      if (error.response) {
        setLoginError(
          error.response.data?.message || 'Giriş başarısız. Bilgilerinizi kontrol edin.'
        );
      } else if (error.request) {
        setLoginError('Sunucudan yanıt alınamadı. Lütfen tekrar deneyin.');
      } else {
        setLoginError('Bir hata oluştu. Lütfen tekrar deneyin.');
      }
    }
  };

  const handleForgotPasswordSubmit = async (e) => {
    e.preventDefault();
    setResetError(null);
    setResetSuccess(false);

    try {
      await api.post('/Auth/ForgetPassword', { email: forgotEmail });
      alert('Kod gönderildi. Lütfen e-postanızı kontrol edin.');
      setIsForgotModalOpen(false);
      setIsResetModalOpen(true);
    } catch (error) {
      setResetError(
        error.response?.data?.message ||
          'Kod gönderilirken hata oluştu. Lütfen geçerli bir e-posta girin.'
      );
    }
  };

  const handleResetPasswordSubmit = async (e) => {
    e.preventDefault();
    setResetError(null);
    setResetSuccess(false);

    if (newPassword.length < 6) {
      setResetError('Şifreniz en az 6 karakter olmalı!');
      return;
    }
    if (newPassword !== confirmPassword) {
      setResetError('Yeni şifre ve tekrar şifre uyuşmuyor.');
      return;
    }

    try {
      await api.post('/Auth/CreateNewPassword', {
        email: forgotEmail,
        code: resetCode,
        password: newPassword,
      });
      setResetSuccess(true);
      alert('Şifreniz güncellendi. Yeni şifrenizle giriş yapabilirsiniz.');
      setIsResetModalOpen(false);
    } catch (error) {
      setResetError(
        error.response?.data?.message ||
          'Şifre güncellenirken hata oluştu. Lütfen kod ve şifreyi kontrol edin.'
      );
    }
  };

  return (
    <div className="app-container">
      <div className="login-container">
        {/* Başlık */}
        <h1>OVVO Takip Sistemi</h1>

        {/* LOGO YERİNE METİN */}
        <div className="logos">
          <div className="brand-as-text">OVVO OLLO GROUP İNŞAAT</div>
        </div>

        <div className="login-form-container">
          <h2>Giriş Yap</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              required
            />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Şifre"
              required
            />
            <button type="submit">Giriş Yap</button>
            {loginError && <p className="error-message">{loginError}</p>}

            <a
              href="#"
              className="forgot-password"
              onClick={(e) => {
                e.preventDefault();
                setForgotEmail('');
                setIsForgotModalOpen(true);
                setResetError(null);
                setResetSuccess(false);
              }}
            >
              Şifremi Unuttum?
            </a>
          </form>
        </div>

        {/* 1) Şifre Sıfırlama Kod Modalı */}
        {isForgotModalOpen && (
          <div className="modal-overlay">
            <div className="modal-content">
              <span className="close-modal" onClick={() => setIsForgotModalOpen(false)}>
                &times;
              </span>
              <h3>Şifre Sıfırlama - Kod Gönder</h3>
              <form onSubmit={handleForgotPasswordSubmit}>
                <input
                  type="email"
                  value={forgotEmail}
                  onChange={(e) => setForgotEmail(e.target.value)}
                  placeholder="Email adresinizi girin"
                  required
                />
                <button type="submit">Kod Gönder</button>
              </form>
              {resetError && <p className="error-message">{resetError}</p>}
            </div>
          </div>
        )}

        {/* 2) Kod + Yeni Şifre Modalı */}
        {isResetModalOpen && (
          <div className="modal-overlay">
            <div className="modal-content">
              <span className="close-modal" onClick={() => setIsResetModalOpen(false)}>
                &times;
              </span>
              <h3>Şifre Sıfırlama - Yeni Şifre</h3>
              <form onSubmit={handleResetPasswordSubmit}>
                <input
                  type="email"
                  value={forgotEmail}
                  readOnly
                  disabled
                  style={{ backgroundColor: '#f2f2f2' }}
                />
                <input
                  type="text"
                  value={resetCode}
                  onChange={(e) => setResetCode(e.target.value)}
                  placeholder="E-posta ile gelen kod"
                  required
                />
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Yeni şifre"
                  required
                />
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Yeni şifre (tekrar)"
                  required
                />
                <button type="submit">Şifreyi Güncelle</button>
              </form>
              {resetError && <p className="error-message">{resetError}</p>}
              {resetSuccess && <p className="success-message">Şifre başarıyla güncellendi!</p>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OvvoLogin;

